<!--选择excle文件并上传页面-->
<template>
  <div>
    <el-row>
      <el-col :span="24">
        <Header></Header>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <MenuList></MenuList>
      </el-col>
      <el-col :span="20">
        <div>
          <el-divider>通过导入模板制作打分表</el-divider>
        </div>

        <div style="padding-left: 20px;font-size: 16px;margin-top: 40px;">
          <div>第一步：根据要导入的打分表类型从下面的列表中下载对应的模板：</div>
          <div style="border: 1px solid lighgray;margin: 10px;">
            <div style="margin: 10px;">
              <a target="_blank" href="/evaluations/import_templates/高级自评导入模板.xlsx">
                高级自评导入模板.xlsx</a>
            </div>
            <div style="margin: 10px;">
              <a target="_blank" href="/evaluations/import_templates/高级互评导入模板.xlsx">
                高级互评导入模板.xlsx</a>
            </div>

            <div style="margin: 10px;">
              <a target="_blank" href="/evaluations/import_templates/开放式单人导入模板.xlsx">
                开放式单人导入模板.xlsx</a>
            </div>
            <div style="margin: 10px;">
              <a target="_blank" href="/evaluations/import_templates/开放式多人导入模板.xlsx">
                开放式多人导入模板.xlsx</a>
            </div>


            <div style="margin: 10px;">
              <a target="_blank" href="/evaluations/import_templates/多维单组导入模板.xlsx">
                多维单组导入模板.xlsx</a>
            </div>
            <div style="margin: 10px;">
              <a target="_blank" href="/evaluations/import_templates/多维多组导入模板.xlsx">
                多维多组导入模板.xlsx</a>
            </div>

            <div style="color:red;font-weight: bold;">注意：一定要用我们的模板填写，否则无法导入</div>

          </div>
        </div>

        <div style="padding-left: 20px;font-size: 16px;margin-top: 40px;">
          <div>第二步：根据下载好的模板填写数据；</div>
        </div>

        <div style="padding-left: 20px;font-size: 16px;margin-top: 40px;">第三步：上传填好的模板文件。<span
            style="color: red;"></span></div>
        <div style="padding: 10px;">
          <div style="padding: 10px;">
            <el-form ref="editForm" :model="editForm" size="mini">
              <div>
                <el-form-item>
                  <el-upload class="upload-demo" :http-request="uploadFile" action :on-preview="handlePreview"
                    :on-remove="handleRemove" :on-change="fileChange" :before-remove="beforeRemove" accept=".xls,.xlsx"
                    multiple :limit="1" :on-exceed="handleExceed" :file-list="fileList">
                    <div class="uploadFileStyle">
                      <el-tooltip class="item" effect="dark"
                        content="如果文件大小超过5M,可能传不上去。减小文件大小的方法是：新建一个excel文件,把旧文件中数据复制粘贴到新文件中保存,新文件会变小。可联系客服免费协助解决."
                        placement="bottom">
                        <el-button type="primary" plain>+点击上传Excel文件(填好的模板文件)</el-button>
                      </el-tooltip>

                      <div slot="tip" class="el-upload__tip" style="font-size: 18px;"></div>
                    </div>
                  </el-upload>
                  <div style="margin-top: 10px;" v-show="fileList.length>0"><el-button type="primary" plain
                      @click="emptyFileList">-删除文件</el-button></div>
                </el-form-item>
              </div>

              <el-form-item size="large">
                <el-tooltip class="item" effect="dark"
                  content="请不要使用IE浏览器.其他浏览器如果点击无反应,把浏览器切换成'高速模式'后重新登录再试试.切换方法见下方帮助." placement="bottom"><el-button
                    size="small" type="primary" @click="importTemplateFile">模板已选择，点我立即导入</el-button></el-tooltip>
              </el-form-item>


            </el-form>
          </div>

        </div>
      </el-col>
    </el-row>

    <el-dialog width="80%" :close-on-click-modal="false" title="如何切换浏览器的模式" :visible.sync="browserSwitchDialogVisible">
      <div class="colStyle">

        如下图所示找到红色框的部分，点击一下，切换到闪电图标上或者是"极速模式"或"高速模式"
        <br /><br />
        <img src="../assets/switch_browser.png" width="100%" />
        <br /><br />
        正确的应该是如下图所示：
        <br /><br />
        <img src="../assets/good_browser.png" width="100%" />
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="browserSwitchDialogVisible=false">我知道了</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'

  export default {
    components: {
      MenuList,
      Header
    },
    data() {
      return {
        username: '',
        browserSwitchDialogVisible: false,
        fileList: [],
        courses: [],
        file: '',
        editForm: {
          id: '',
          exam: '',
          course: '',
          grade: '',
          paper_score: ''
        }
      }
    },
    created() {
      this.username = this.$session.get('USERNAME') // 获取session
      // console.log('调用exam_list created')
      // this.loadCourses()
    },
    methods: {
      handleRemove(file, fileList) {
        this.fileList = []
      },
      handlePreview(file) {},
      uploadFile(file) {
        // this.data.append('file', file.file)
      },
      handleExceed(files, fileList) {
        this.$message.warning(`请先删除原来上传的文件后再上传!`)
        return true
      },
      beforeRemove(file, fileList) {
        return this.$confirm(`确定移除 ${file.name}？`)
      },
      importTemplateFile() {
        if (this.fileList.length === 0) {
          this.$message.error('请上传excel文件！')
          return
        }

        let that = this

        let tmpExcelFile = this.fileList[0].raw

        // 上传前先校验文件类型，避免上传了非Excel文件
        var lowerName = tmpExcelFile.name.toLowerCase()
        if (!lowerName.endsWith('.xls') && !lowerName.endsWith('.xlsx')) {
          this.$message.error('您选择的文件「' + tmpExcelFile.name +
            '」不是Excel文件（后缀需为 .xls 或 .xlsx），无法导入。请从本页面下载模板填写后再上传！')
          return
        }

        let data = new FormData()
        data.set('equipment', this.username)

        // console.log(tmpExcelFile)

        data.append('file', tmpExcelFile)

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/evaluations/web/_import_score_form.jsp'
        this.axios.post(requestUrl, data, {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          // 后端导入前会先进行文件校验，设置足够的上传超时，避免误判为上传失败
          timeout: 360000
        }).then(res => {
          console.log('数据导入完成！！', res.data)

          load.close()

          // 后端返回的不是 JSON 格式，通常是文件本身有问题
          if (typeof res.data === 'string') {
            that.fileList = []
            var rawMsg = '系统无法解析您上传的文件，说明文件格式有问题。\n\n'
              + '最可能的原因是您没有使用本页面下载的模板，或者模板被其他软件修改过。\n\n'
              + '请按以下步骤解决：\n'
              + '1. 从本页面重新下载对应类型的模板\n'
              + '2. 用WPS打开模板，将模板中的红色示例文字替换为您的实际数据\n'
              + '3. 不要增删或修改模板的列（表头保持原样）\n'
              + '4. 不要修改Excel底部的工作表名称\n'
              + '5. 填写完成后直接保存，不要用其他软件另存或转换格式'
            that.showImportError('导入失败', rawMsg)
            return
          }

          if (res.data.result == '1') {
            that.$router.push('/form_list')
          } else if (res.data.result == '-2') {
            // 文件超限
            that.fileList = []
            var exceedMsg = '您的Excel文件太大了，超过了系统允许的上限（5MB），无法导入。\n\n'
              + '请按以下方法处理：\n'
              + '1. 用WPS打开文件，选中数据区域以外的空白行和空白列，右键删除，然后另存为新文件，文件会变小\n'
              + '2. 如果数据量确实很多，请拆分成多个Excel文件分别导入\n'
              + '3. 正常的Excel模板文件一般只有几十KB，如果您的文件很大，说明文件里可能包含了多余的空行或格式信息'
            that.showImportError('导入失败', exceedMsg)
          } else if (res.data.result == '-3') {
            // 模板不匹配：优先展示后端返回的详细信息
            that.fileList = []
            var templateErrMsg = ''
            if (res.data.message && res.data.message != '') {
              // 后端已返回详细错误（包含实际Sheet名和期望Sheet名）
              templateErrMsg = res.data.message + '\n\n'
            } else {
              templateErrMsg = '系统无法识别您上传的文件，原因可能是：\n'
                + '1. 您没有使用从本页面下载的模板，而是用了自己创建的Excel文件\n'
                + '2. 您修改了Excel底部的工作表名称（系统通过工作表名称来识别模板类型）\n'
                + '3. 您下载的模板类型不对（比如要导入高级自评却下载了高级互评模板）\n\n'
            }
            templateErrMsg += '请重新下载正确的模板，填写数据后直接上传，不要修改工作表名称和表头。'
            that.showImportError('导入失败', templateErrMsg)
          } else if (res.data.result == '-10') {
            // 数据格式错误：展示后端返回的具体错误信息
            that.fileList = []
            var msg_str = res.data.message
            var errContent = ''
            if (msg_str && msg_str != '') {
              errContent = msg_str + '\n\n'
            } else {
              errContent = '数据格式有误，请检查填写内容。\n\n'
            }
            errContent += '请打开Excel文件逐项检查：\n'
              + '1. 是否有空白行或该填的单元格漏填了\n'
              + '2. 数字列是否填了文字（如"最高分"列填了"优秀"而不是数字）\n'
              + '3. 是否从模板第3行开始填写数据（前两行是表头，不要跳过）\n'
              + '4. 有没有多出或删除了模板原有的列\n'
              + '5. 用WPS打开模板，另存为新文件后再试一次'
            that.showImportError('导入失败', errContent)
          } else {
            // 其他未知错误
            that.fileList = []
            var unknownMsg = ''
            if (res.data.message && res.data.message != '') {
              unknownMsg = res.data.message + '\n\n'
            } else if (res.data.result) {
              unknownMsg = '导入失败，错误代码：' + res.data.result + '\n\n'
            } else {
              unknownMsg = '导入失败，原因未知。\n\n'
            }
            unknownMsg += '请检查以下几点：\n'
              + '1. Excel中是否确实填写了数据（打开文件确认内容没有丢失）\n'
              + '2. 数据是否填在了正确的Sheet页（查看Excel底部标签，确保数据在第一个工作表里）\n'
              + '3. 模板文件是否损坏（重新从本页面下载模板再填写一次）'
            that.showImportError('导入失败', unknownMsg)
          }

        }).catch(err => {
          console.log('数据导入异常！！')
          console.log(err)
          load.close()

          that.fileList = []
          var failMsg = '文件上传到服务器失败，通常是因为网络不稳定或文件太大。\n\n'
            + '请尝试：\n'
            + '1. 切换到稳定的网络后重试\n'
            + '2. 检查文件是否超过5MB，如果超过请先用WPS删除多余空白行列\n'
            + '3. 刷新页面重新登录后再试'
          that.showImportError('导入失败', failMsg)
        })
      },
      // Element UI 的 MessageBox 默认不渲染 \n 换行，需要先转义HTML特殊字符再把换行转为<br/>，弹窗才能正常显示多行文本
      showImportError(title, msg) {
        var htmlMsg = (msg || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
          .replace(/\n/g, '<br/>')
        this.$alert(htmlMsg, title, {
          dangerouslyUseHTMLString: true
        })
      },

      fileChange(file, fileList) {
        this.fileList = fileList
        console.log(fileList)
        return true
      },
      back() {
        this.$router.push('/exam_list')
      },
      emptyFileList() {
        this.fileList = []
      },
      howToSwitch() {
        this.browserSwitchDialogVisible = true
      }

    }
  }
</script>

<style>
  .actionStyle {
    display: flex;
    flex-direction: column;

  }

  .uploadFileStyle {
    display: flex;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/import_excel_from_template.vue